import { Component } from '@angular/core';
import { CustomErrorHandler } from '@questrade/flx-commons';
import { DeveloperProvider } from '../../../../providers/developers';
import { IonicPage } from 'ionic-angular/navigation/ionic-page';
import { NavController, NavParams, Events } from 'ionic-angular';
import { environment } from './../../../../environments/environment';

@IonicPage({
  name: 'ext-magento-1',
  defaultHistory: ['home']
})
@Component({
  selector: 'page-ext-magento-1',
  templateUrl: 'ext-magento-1.html',
})
export class ExtMagento_1Page {
  docuData;
  constructor(
    public events: Events,
    public navCtrl: NavController,
    public navParams: NavParams,
    private devProvider: DeveloperProvider,
    private customErrorHandler: CustomErrorHandler) {
    this.events.publish('menu:changed', true, 'ext-magento-1');
    this.docuData = [
      {
        title: 'Flexiti Payment Installation for Magento 1',
        description: `
        <div class="page-ext-magento-1">
          <span class="page-ext-magento-1__description">
            Flexiti modules are easy to install. All you need is to have FTP/SSH access details,
            and follow 3 steps to complete.
            <br>

            <a href="`+ environment.PUBLIC + `libs/SDK/zip/FlxPaymentExtension_v1.0.0-20180314.zip">
              download extension here
            </a>
            <br>
            <strong>
              Steps:
            </strong>
          </span>
          <ul class="page-ext-magento-1__list">
            <li>Unpack the downloaded "zip" file.</li>
            <li>Upload all files Magento installation root folder.</li>
            <li>Clear the cache.</li>
          </ul>
          <br>
        </div>
        `,
        img: "./assets/magento-setup/1.png",
      },
      {
        title: 'Flexiti Payment Setup',
        description: `
          <div class="page-ext-magento-1">
            <span class="page-ext-magento-1__description">
              Go to Flexiti Payment configuration in the Magento Admin Panel :
              <br>
              <strong>System->Configuration->Sales->Payment Methods</strong>
              <br>
              and complete the fields with your developer account information
              <br>
              <strong>Params:</strong>
            </span>
            <ul class="page-ext-magento-1__list">
              <li>Merchant Client ID: It's the given client id in account information</li>
              <li>Merchant Client Secret: It's the given client id in account information</li>
              <li>Api URL for token: </li>
              <ul class="page-ext-magento-1__list">
                <li>For UAT (testing) integration use: <strong>https://onlineapi-uat.flexiti.fi/flexiti/online-api/oauth/token</strong>
                <li>For PROD integration use <strong>https://onlineapi.flexiti.fi/flexiti/online-api/oauth/token</strong>
                  </br>
                  (take into account you should request prod credentials first)
                </li>
              </ul>
            </ul>
          </div>
        `,
        img: "./assets/magento-setup/2.png"
      },
      {
        title: 'Configure redirection URL',
        description: `
          <div class="page-ext-magento-1">
            <span class="page-ext-magento-1__description">
              Next step will be allow callback urls in your flexiti account, to do that,
              login with your credentials in Flexiti developer portals and fill following fields with:
            </span>
            </br>
            <ul class="page-ext-magento-1__list">
              <li>your magento cart host name + /flexiti/index/success for success redirections.</li>
              <li>your magento cart host name + /flexiti/index/failure for error redirections.</li>
            </ul>
            </br>
            <strong> Example: </strong>
            </br>
          </div>
        `,
        img: "./assets/magento-setup/3.png"
      }
    ];
  }

  handleDownloadExtension() {
    window.open(environment.PUBLIC + 'libs/SDK/zip/FlxPaymentExtension_v1.0.0-20180314.zip');
  }

  handleDownloadTheme() {
    window.open(environment.PUBLIC + 'libs/SDK/zip/FlxPaymentTheme_v1.0.0-20180314.zip');
  }


}



// WEBPACK FOOTER //
// ./src/pages/extensions/ext-platforms/ext-magento-1/ext-magento-1.ts